<div class="modal-header">
  <h5 class="modal-title">Colar sem formatação</h5>
  <button type="button" class="close modal-x-button" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <form [formGroup]="formGroup">
        <div class="form-group">
          <label for="content">Conteúdo *</label>
          <textarea formControlName="content" class="form-control" id="content" rows="10"
              [ngClass]="{ 'is-invalid': submitted && formGroup.get('content').hasError('required') }">
          </textarea>
          <small class="invalid-feedback" *ngIf="submitted && formGroup.get('content').hasError('required')">
            Conteúdo não foi fornecido
          </small>
        </div>
        <div class="h-100 d-flex justify-content-between">
          <button type="button" (click)="activeModal.dismiss()" class="btn btn-outline-dark w-100">
            Voltar
          </button>
          <button #okBtn type="button" [attr.data-loader]="!submitted" btnloader class="btn btn-primary mainBackground-color ml-2 w-100"
          (click)="submit()">
            Ok
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
